export {inputText2 as InputText2} from "./input"
export {inputNumber2 as InputNumber2} from "./input"
export {inputDate2 as InputDate2} from "./input"